<div>
  <div class="flex justify-end">
    <button class="bg-red-600 flex items-center justify-center !text-white p-1 rounded-md" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="p-3 text-center">
    <h3 class="mb-3">
      Mrejesho wako umetumwa. Namba ya kumbukumbu kwa ajili ya kufanya ufuatiliaji ni:
    </h3>
    <div class="flex items-center justify-center gap-2">
      <span class="!font-black px-3 py-2 rounded-md mr-3 !bg-primary-100 !text-3xl">{{trackNumber}}</span>
      <button class="!bg-primary-600 !text-white p-1 rounded-md" (click)="copyToClipboard()">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </div>
</div>
